import React, { useState } from 'react'
import { Container } from '@material-ui/core'
import { useTranslation } from "react-i18next"
import { Field } from '@progress/kendo-react-form'
import { Grid } from "@material-ui/core"
import './direction.css'
import { Fragment } from 'react'
import { Tooltip } from '@progress/kendo-react-tooltip'
import { Label } from '@progress/kendo-react-labels'

const TooltipContentTemplate = (props) => {
  return (
    <a>
      <strong>{props.title}</strong>
      <p>{props.content}</p>
      <p>{props.subContent}</p>
      <p>{props.restContent}</p>
    </a>
  );
};


/**
 * @param {*} props
 * @return {*} 
 * @status no delete
 */
function DirectionPure(props) {
  const { t } = useTranslation()
  const [firstName, setFirstName] = useState(false)
  const [firstLastName, setFirstLastName] = useState(false)
  const [secondLastName, setSecondLastName] = useState(false)
  const [rfc, setRfc] = useState(false)
  const [phoneNumber, setPhoneNumber] = useState(false)
  const [cellNumber, setCellNumber] = useState(false)
  const [street, setStreet] = useState(false)
  const [colony, setColony] = useState(false)
  const [township, setTownship] = useState(false)
  const [state, setState] = useState(false)
  const [zipCode, setZipCode] = useState(false)

  const iconTooltipStyles = {
    color: '#687687',
    fontSize: '15px',
    // marginLeft: '5px',
    padding: '5px',
    cursor: 'pointer'
  }

  const [open, setOpen] = useState(false);
  const handleOnChangeTooltip = () => setOpen(!open)
  const hiddeTooltip = () => setOpen(false)
  const { selectedPersonTypeId } = props

  return (
    <Fragment>
      <Container className='direction-display-flex' spacing={6} lg={12} md={12} sm={6} xs={12} >
        <fieldset className='direction-field'>
          <Grid container className='container direction-display-block' spacing={4}>
            <div className='direction-tooltip-movil'>
              <Label className="direction-form-labels ">
                {t('register.personalData.name')}
              </Label>
            </div>
            <Grid className='direction-grid-complete' item xs={12} lg={6} md={12} sm={12} es={12}>

              <div className='direction-input-movil'>
                <Field
                  className='direction-input-data'
                  onFocus={() => { setFirstName(false) }}
                  onBlur={() => { setFirstName(true) }}
                  name={"firstName"}
                  component={props.validateInput}
                  validator={firstName && props.validator.nameValidator}
                  minLength={2} required
                  autoFocus
                />
              </div>
            </Grid>
            <span className='direction-display-span'> {t('register.personalData.firstLastName')}</span>
            <Grid className='direction-grid-complete' item xs={12} lg={6} md={12} sm={12} es={12}>

              <div className='direction-input-movil'>
                <Field
                  className='direction-input-data'
                  onFocus={() => { setFirstLastName(false) }}
                  onBlur={() => { setFirstLastName(true) }}
                  name={"firstLastName"}
                  component={props.validateInput}
                  validator={firstLastName && props.validator.firstLastNameValidator}
                  minLength={2}
                  required
                />
              </div>
            </Grid>
            <span className='direction-display-span'> {t('register.personalData.secoundLastName')}</span>
            <Grid className='direction-grid-complete' item xs={12} lg={6} md={12} sm={12} es={12}>

              <div className='direction-input-movil'>
                <Field
                  className='direction-input-data'
                  onFocus={() => { setSecondLastName(false) }}
                  onBlur={() => { setSecondLastName(true) }}
                  name={"secondLastName"}
                  component={props.validateInput}
                  validator={secondLastName && props.validator.secondLastNameValidator}
                  minLength={2}
                  required
                />
              </div>
            </Grid>
            <span className='direction-display-span'> {t('register.personalData.cellphone')}</span>
            <Grid className='direction-grid-complete' item xs={12} lg={6} md={12} sm={12} es={12}>

              <div className='direction-input-movil'>
                <Field
                  className='direction-input-data'
                  onFocus={() => { setCellNumber(false) }}
                  onBlur={() => { setCellNumber(true) }}
                  name={"cellphoneNumber"} component={props.validateInput}
                  validator={cellNumber && props.validator.cellphoneValidator}
                  maxLength={12}

                />
              </div>
            </Grid>
          </Grid>
        </fieldset>
      </Container>
    </Fragment>
  )
}

export { DirectionPure as default }
